import React from "react";
import { BrowserRouter } from "react-router-dom";
import RoutePage from "./Component/Route/route";
import { role } from "./Component/enum";
import { Auth } from "aws-amplify";
import {
  getUserDetailsByEmail,
  getRequireMfabyClientSql,
  AddUserAndRolesForAzure,
} from "./libs/API";
import AzureAdGroupMapping from "./libs/AzureAdGroupMapping.json";

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      hasAuthenticated: false,
      isAuthenticating: true,
      loggedInUser: "",
      hasManageMetadataTemplate: false,
      hasManageRepositories: false,
      hasEditIndex: false,
      hasManageRedaction: false,
      hasManageUsers: false,
      hasTextSearch: false,
      hasManageFiles: false,
      hasDelete: false,
      hasCliftonWorkflow: false,
      hasLyndhurstWorkflow: false,
      hasWayneWorkflow: false,
      hasEnglewoodWorkflow: false,
      hasFoveonicsAdmin: false,
      hasSendEmail: false,
      hasMedfordWorkflow: false,
      hasRestrictAccessByIP: false,
      hasDownloadIndex: false,
      hasFileProperties: false,
      hasGlenrockWorkflow: false,
      hasAberdeenWorkflow: false,
      userIpAddress: "",
      userId: "",
      hasOcrRole: false,
      hasPIIRole: false,
      hasDemoExpungementWorkflow: false,
      hasEastamptonExpungementWorkflow: false,
      hasSomervilleExpungementWorkflow: false,
      clientId: 0,
      groups: null,
      requireMfa: false,
      hasArchiveRole: false,
      hasManageClientsUserRole: false,
      hasPrintWithAnnotationsRole: false,
      hasRaritanExpungementWorkflow: false,
      hasWhiteRedaction: false,
    };
    this.userHasAuthenticated = this.userHasAuthenticated.bind(this);
  }

  async componentDidMount() {
    try {
      // Try to get current authenticated user (will throw if not signed in)
      await Auth.currentAuthenticatedUser();
      // Only call setUserPermissions if user is already signed in
      // this only because if i am authenticated,and reload page inorder to reload the page i am, that why calling setpermissions
      //from component did mount.
      await this.setUserPermissions();
    } catch (e) {
      // Not signed in → make sure app state reflects that
      try {
        // wipe any stale, app-held flags (your header clearTokens does the same)
        this.userHasAuthenticated(false);
      } catch {}
    }

    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = (passedAuthenticated) => {
    this.setState({ hasAuthenticated: passedAuthenticated });
  };

  getDsGroupsFromAzureGroups = (azureGroupIds = []) => {
    try {
      if (!Array.isArray(azureGroupIds)) {
        return { dsGroups: [], clientName: null, authorized: false };
      }

      const dsGroups = [];
      let foundValidGroup = false;
      let clientName = null;

      for (const id of azureGroupIds) {
        for (const client of AzureAdGroupMapping.clients) {
          // Check if id matches clientId
          if (client.clientId.toString() === id.toString()) {
            clientName = client.clientName;
          }

          // Now check inside groups of this client
          const group = client.groups?.find((g) => g.groupId === id);
          if (group?.dsGroups?.length) {
            dsGroups.push(...group.dsGroups);
            foundValidGroup = true;

            // Set clientName if not already set
            if (!clientName) {
              clientName = client.clientName;
            }
          }
        }
      }

      return {
        clientName,
        dsGroups,
        authorized: foundValidGroup,
      };
    } catch (error) {
      return { dsGroups: [], clientName: null, authorized: false };
    }
  };

  setUserPermissions = async (ip, azureClientId) => {
    // prevent re-entry (e.g. in strict mode)
    if (this.state.hasAuthenticated) return;

    try {
      // 1. Get Cognito user
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      let email = user.attributes?.email;

      // 2. If email not from attributes, extract from token (federated/Azure)
      if (!email) {
        const session = await Auth.currentSession();
        const payload = session.getIdToken().decodePayload();
        email = payload.email;

        let rawAzureGroups = payload["custom:azure_groups"] || [];
        if (typeof rawAzureGroups === "string") {
          try {
            rawAzureGroups = JSON.parse(rawAzureGroups);
            console.log("parsed azure groups", rawAzureGroups);
          } catch {
            rawAzureGroups = [];
          }
        }

        const hintedClientId = parseInt(azureClientId, 10) || 0;

        if (hintedClientId) {
          // Example:
          await AddUserAndRolesForAzure(
            email,
            rawAzureGroups,
            hintedClientId > 0 ? hintedClientId : 0
          );
        }

        // if (!authorized) {
        //   alert("You are not authorized to access this application.");
        //   await Auth.signOut();
        //   return;
        // }
      }

      // 3. Fetch user details exactly once
      const userDetails = await getUserDetailsByEmail(email);

      // 4. Build flags from roles
      const groups = userDetails.map((d) => d.name);
      const clientId = userDetails[0]?.clientId;
      const requireMfa = clientId
        ? await getRequireMfabyClientSql(clientId)
        : false;

      this.setState({
        loggedInUser: email,
        userId: user.username,
        userIpAddress: ip,
        clientId,
        groups,
        requireMfa,
        hasManageMetadataTemplate: groups.includes(
          role.documentSync_Manage_Metadata_Template
        ),
        hasManageRepositories: groups.includes(
          role.documentSync_Manage_Repositories
        ),
        hasEditIndex: groups.includes(role.documentSync_Edit_Index),
        hasManageRedaction: groups.includes(
          role.documentSync_Manage_Redactions
        ),
        hasManageUsers: groups.includes(role.documentSync_Manage_Users),
        hasTextSearch: groups.includes(role.documentSync_Text_Search),
        hasManageFiles: groups.includes(role.documentSync_Manage_Files),
        hasDelete: groups.includes(role.documentSync_Delete),
        hasCliftonWorkflow: groups.includes(
          role.documentSync_CliftonExpungementWorkflow
        ),
         hasLyndhurstWorkflow: groups.includes(
          role.documentSync_LyndhurstExpungementWorkflow
        ),
         hasWayneWorkflow: groups.includes(
          role.documentSync_WayneExpungementWorkflow
        ),
        hasFoveonicsAdmin: groups.includes(role.foveonicsAdmin),
        hasSendEmail: groups.includes(role.documentSync_Email),
        hasMedfordWorkflow: groups.includes(
          role.documentSync_MedfordExpungementWorkflow
        ),
        hasGlenrockWorkflow: groups.includes(
          role.documentSync_GlenrockExpungementWorkflow
        ),
        hasEnglewoodWorkflow: groups.includes(
          role.documentSync_EnglewoodExpungementWorkflow
        ),
        hasAberdeenWorkflow: groups.includes(
          role.documentSync_AberdeenExpungementWorkflow
        ),
        hasRestrictAccessByIP: groups.includes(
          role.documentSync_RestrictAccessByIP
        ),
        hasDownloadIndex: groups.includes(role.documentSync_DownloadIndex),
        hasFileProperties: groups.includes(role.documentSync_FileProperties),
        hasOcrRole: groups.includes(role.documentSync_OCR),
        hasPIIRole: groups.includes(role.documentSync_PII),
        hasDemoExpungementWorkflow: groups.includes(
          role.documentSync_DemoExpungementWorkflow
        ),
        hasSomervilleExpungementWorkflow: groups.includes(
          role.documentSync_SomervilleExpungementWorkflow
        ),
        hasEastamptonExpungementWorkflow: groups.includes(
          role.documentSync_EastamptonExpungementWorkflow
        ),
        hasArchiveRole: groups.includes(role.documentSync_Archive),
        hasManageClientsUserRole: groups.includes(
          role.documentSync_ManageClients
        ),
        hasPrintWithAnnotationsRole: groups.includes(
          role.documentSync_PrintWithAnnotations
        ),
        hasRaritanExpungementWorkflow: groups.includes(
          role.documentSync_RaritanExpungementWorkflow
        ),
        hasWhiteRedaction: groups.includes(role.documentSync_WhiteRedaction),
      });

      // 5. Notify authentication is ready
      this.userHasAuthenticated(true);
    } catch (error) {
      console.error("Error in setUserPermissions:", error);
      // Optionally handle sign-out or redirect here
    }
  };

  render() {
    const childProps = {
      hasAuthenticated: this.state.hasAuthenticated,
      loggedInUser: this.state.loggedInUser,
      hasManageMetadataTemplate: this.state.hasManageMetadataTemplate,
      hasManageRepositories: this.state.hasManageRepositories,
      hasEditIndex: this.state.hasEditIndex,
      hasManageRedaction: this.state.hasManageRedaction,
      hasManageUsers: this.state.hasManageUsers,
      hasManageFiles: this.state.hasManageFiles,
      hasTextSearch: this.state.hasTextSearch,
      hasDelete: this.state.hasDelete,
      hasCliftonWorkflow: this.state.hasCliftonWorkflow,
      hasLyndhurstWorkflow: this.state.hasLyndhurstWorkflow,
      hasWayneWorkflow: this.state.hasWayneWorkflow,
      hasEnglewoodWorkflow: this.state.hasEnglewoodWorkflow,
      hasFoveonicsAdmin: this.state.hasFoveonicsAdmin,
      hasSendEmail: this.state.hasSendEmail,
      hasMedfordWorkflow: this.state.hasMedfordWorkflow,
      hasGlenrockWorkflow: this.state.hasGlenrockWorkflow,
      hasRestrictAccessByIP: this.state.hasRestrictAccessByIP,
      hasDownloadIndex: this.state.hasDownloadIndex,
      hasFileProperties: this.state.hasFileProperties,
      userIpAddress: this.state.userIpAddress,
      userId: this.state.userId,
      hasOcrRole: this.state.hasOcrRole,
      hasPIIRole: this.state.hasPIIRole,
      clientId: this.state.clientId,
      hasAberdeenWorkflow: this.state.hasAberdeenWorkflow,
      hasDemoExpungementWorkflow: this.state.hasDemoExpungementWorkflow,
      hasEastamptonExpungementWorkflow:
        this.state.hasEastamptonExpungementWorkflow,
      setUserPermissions: this.setUserPermissions,
      userHasAuthenticated: this.userHasAuthenticated,
      groups: this.state.groups,
      requireMfa: this.state.requireMfa,
      hasArchiveRole: this.state.hasArchiveRole,
      hasManageClientsUserRole: this.state.hasManageClientsUserRole,
      hasSomervilleExpungementWorkflow:
        this.state.hasSomervilleExpungementWorkflow,
      hasPrintWithAnnotationsRole: this.state.hasPrintWithAnnotationsRole,
      hasRaritanExpungementWorkflow: this.state.hasRaritanExpungementWorkflow,
      hasWhiteRedaction: this.state.hasWhiteRedaction,
    };
    //console.log("childProps", childProps);
    return (
      !this.state.isAuthenticating && (
        <BrowserRouter>
          <div className="App"></div>
          <RoutePage props={childProps} />
        </BrowserRouter>
      )
    );
  }
}

export default App;
